// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SetupFields_fields__gBAaD{display:flex;flex-direction:column;gap:16px}`, "",{"version":3,"sources":["webpack://./src/apps/admin/pages/NewCalendarPage/SetupFields.module.scss"],"names":[],"mappings":"AAAA,2BACE,YAAA,CACA,qBAAA,CACA,QAAA","sourcesContent":[".fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fields": `SetupFields_fields__gBAaD`
};
export default ___CSS_LOADER_EXPORT___;
